export const topAttractionsSlides = [
    {
    id: 'ai-apps-solutions',
    category: 'Featured Sections',
    title: 'AI & Business Automation',
    description:
      'Automate repetitive tasks, respond faster to customers, and improve internal efficiency with AI for business automation, smart workflows, and tailored digital systems.',
    imageSrc:
      '/assets/img-26.jpg',
    imageAlt: 'AI automation and smart business systems',
    href: '/services/ai-apps-solutions',
  },
  {
    id: 'website-design-development',
    category: 'Featured Sections',
    title: 'High-Converting Websites',
    description:
      'We build fast, modern, and conversion-focused websites as a web development company in Switzerland, helping businesses strengthen trust and turn visitors into customers.',
    imageSrc:
      '/assets/img-31.jpg',
    imageAlt: 'Website development workspace with laptop and code',
    href: '/services/website-design-development',
  },

 {
  id: 'ecommerce-development',
  category: 'Featured Sections',
  title: 'E-commerce Development',
  description:
    'Custom online stores built to sell, scale, and create smoother shopping experiences. Our eCommerce solutions are designed for businesses that want stronger performance and long-term digital growth.',
  imageSrc:
    '/assets/img-33.jpg',
  imageAlt: 'E-commerce development and online store design',
  href: '/services/ecommerce-development',
},
];